import { render, staticRenderFns } from "./NutricaoPacientes.vue?vue&type=template&id=bb4ecd68&scoped=true&"
import script from "./NutricaoPacientes.vue?vue&type=script&lang=js&"
export * from "./NutricaoPacientes.vue?vue&type=script&lang=js&"
import style0 from "./NutricaoPacientes.vue?vue&type=style&index=0&id=bb4ecd68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4ecd68",
  null
  
)

export default component.exports